import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'
import {
  convertVisibleIf,
  convertTriggers,
  convertQuestionMappings,
  q,
  v,
} from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
    // useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const selfAnswer = '({q1} = 1)'
  const familyAnswer = '({q1} = 2)'

  const visibleIfConditionsInit = convertVisibleIf({
    // 用1開始計算填這裡，工具自動轉成0開始
    // P260407164822624?sfd_p_id=1140941&sfd_sampler_id=101001801

    q6: familyAnswer,
    q7: familyAnswer,

    q8: selfAnswer,
    q9: selfAnswer,
    q10: selfAnswer + ' and ({q9} = 7)',
    q11: selfAnswer,
    q12: selfAnswer + ' and ({q11} = 7)',
    q13: selfAnswer,
    q14: selfAnswer + ' and ({q13} = 7)',
    q15: selfAnswer,
    q16: selfAnswer + ' and ({q15} anyof [5, "none"])',

    q17: selfAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q18: selfAnswer + ' and ({q4} >= 98 and {q4} <= 115)',
    q19: selfAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q20:
      selfAnswer +
      ' and (({q4} >= 1 and {q4} <= 97) or ({q4} = 116)) and ({q19} >= 2 and {q19} <= 4)',
    q21: selfAnswer + ' and ({q20} = 8)',
    q22:
      selfAnswer +
      ' and (({q4} >= 1 and {q4} <= 97) or ({q4} = 116)) and ({q19} >= 2 and {q19} <= 4)',

    q23: selfAnswer,
    q24: selfAnswer + ' and ({q23} >= 1 and {q23} <= 4)',
    q25: selfAnswer,
    q26: selfAnswer + ' and ({q25} = "other")',
    q27: selfAnswer,
    q28: selfAnswer,
    q29: selfAnswer,
    q30: selfAnswer,

    q31: selfAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q32: selfAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',

    q33: familyAnswer,
    q34: familyAnswer,
    q35: familyAnswer + ' and ({q34} = 7)',
    q36: familyAnswer,
    q37: familyAnswer + ' and ({q36} = 7)',
    q38: familyAnswer,
    q39: familyAnswer + ' and ({q38} = 7)',
    q40: familyAnswer,
    q41: familyAnswer + ' and ({q40} anyof [5, "none"])',
    q42: familyAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q43: familyAnswer + ' and ({q4} >= 98 and {q4} <= 115)',
    q44: familyAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q45:
      familyAnswer +
      ' and (({q4} >= 1 and {q4} <= 97) or ({q4} = 116)) and ({q44} >= 2 and {q44} <= 4)',
    q46: familyAnswer + ' and ({q45} = 8)',
    q47:
      familyAnswer +
      ' and (({q4} >= 1 and {q4} <= 97) or ({q4} = 116)) and ({q44} >= 2 and {q44} <= 4)',
    q48: familyAnswer,
    q49: familyAnswer + ' and ({q48} >= 1 and {q48} <= 4)',
    q50: familyAnswer,
    q51: familyAnswer + ' and ({q50} = "other")',
    q52: familyAnswer,
    q53: familyAnswer,
    q54: familyAnswer,
    q55: familyAnswer,
    q56: familyAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',
    q57: familyAnswer + ' and ({q4} >= 1 and {q4} <= 97) or ({q4} = 116)',

    q59: '({q58} = 2)',
    q62: '({q61} = 1)',

    q63: '({q4} >= 1 and {q4} <= 97)',

    q64: '({q4} >= 1 and {q4} <= 97) and ({q8} anyof [1, 2, 3] or {q9} anyof [1, 2, 3])',
    q65: '({q64} anyof [1])',
    q66: '({q64} anyof [2])',
    q67: '({q64} anyof [3])',
  })
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = convertTriggers([
    // {
    //   type: 'complete',
    //   expression: `({q7} = 1) or ({q11} anyof [1, 2, 3, 4, 5, 6, 7, 8, 9, "other"])`,
    // },
  ])
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入 (用1開始計算填這裡)
  const questionMappings = convertQuestionMappings({
    // q37: 'q38',
  })

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    sfdSamplerId,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q7)', survey.getValue('q7'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (survey.getValue(q(7)) === v(1) || survey.getValue(q(11))?.length > 0) {
    //   setCompletionMessage(endMessage)
    // } else {
    setCompletionMessage(
      `<div>非常感謝您接受我們的訪問，祝您有個愉快的一天，謝謝您！~</div>`
    )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login || !!sfdSamplerId,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
